import { Game } from "../../Game";
import { TargetZone } from "./TargetZone";



export const enum eTargetType {
    round,
    fireRing,
    corner,
    bonus,

    NUMBER
}



export class TargetType {
    /**
     * (RO) Typ terce
     */
    get type(): eTargetType { return this._type; }
    private _type: eTargetType;
    /**
     * (RO) Jmeno framu v textura atlasu
     */
    get frameKey(): string { return "targets/" + this._type + "_00"; }
    /**
     * (RO) Velikost obrazku terce v pixelech
     */
    get pixelSize(): pc.Vec2 { return this._pixelSize; }
    private _pixelSize: pc.Vec2;
    /**
     * (RO) Seznam zon terce
     */
    get zones(): TargetZone[] { return this._zones; }
    private _zones: TargetZone[];
    /**
     * (RO) Offset ulomku terce od stredu
     */
    get shardOffsets(): pc.Vec2[] { return this._shardOffsets; }
    private _shardOffsets: pc.Vec2[];

    /**
     * (RO) True, pokud se terc po zasahu rozpadne na ulomky
     */
    get hasShards(): boolean { return this._shardOffsets != undefined; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: eTargetType, zones: TargetZone[], posOfShards?: number[]) {
        this._type = type;
        this._zones = zones;

        let frameRc = (Game.atlas.frames[this.frameKey] as pc.TextureAtlasFrame).rect;
        let targetW = frameRc.z;
        let targetH = frameRc.w;

        this._pixelSize = new pc.Vec2(targetW, targetH);

        if (posOfShards) {
            let targetCenterX = Math.round(targetW / 2);
            let targetCenterY = Math.round(targetH / 2);
            let shardCnt = posOfShards.length >> 1;

            this._shardOffsets = [];

            for (let shardId = 0; shardId < shardCnt; shardId++) {
                this._shardOffsets.push(new pc.Vec2((posOfShards[shardId << 1] - targetCenterX) / frameRc.z, -(posOfShards[(shardId << 1) + 1] - targetCenterY) / targetH));
            }
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci zonu nebo null, pokud zona na dane pozici neni
     * @param radiusRatio Vzdalenost od stredu jako pomer vuci polomeru terce. Cele cislo v rozsahu 0 az 100
     */
    //-------------------------------------------------------------------------
    getZone(radiusRatio: number): TargetZone {
        for (let zoneId = 0; zoneId < this._zones.length; zoneId++) {
            let zone = this._zones[zoneId];

            if (radiusRatio <= zone.outerRadiusRatio)
                return zone;
        }

        return null;
    }
}